package ru.villawonka.app.data.entity.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.RentTypeDomain

@Serializable
enum class RentTypeDto {
    @SerialName("daily") DAILY,
    @SerialName("monthly") MONTHLY,
    @SerialName("annually") ANNUALLY,
    @SerialName("period") PERIOD
}

fun RentTypeDto.toDomain() = when (this) {
    RentTypeDto.PERIOD -> RentTypeDomain.PERIOD
    RentTypeDto.DAILY -> RentTypeDomain.DAILY
    RentTypeDto.MONTHLY -> RentTypeDomain.MONTHLY
    RentTypeDto.ANNUALLY -> RentTypeDomain.ANNUALLY
}